import { render, staticRenderFns } from "./MainFortuneWheelFilters.vue?vue&type=template&id=255dfa64&"
import script from "./MainFortuneWheelFilters.vue?vue&type=script&lang=js&"
export * from "./MainFortuneWheelFilters.vue?vue&type=script&lang=js&"
import style0 from "./MainFortuneWheelFilters.vue?vue&type=style&index=0&id=255dfa64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports